import { api } from "@/lib/api";

export const DashboardAPI = {
  config: () => api.get("/me/dashboard").then((r) => r.data),
  saveConfig: (widgets) => api.put("/me/dashboard", { widgets }).then((r) => r.data),
  stats: (params) => api.get("/me/dashboard/stats", { params }).then((r) => r.data),
};
